<nav class="xng-breadcrumb-root" aria-label="breadcrumb">
  <ol class="xng-breadcrumb-list">
    @for (
      breadcrumb of breadcrumbs$ | async;
      track breadcrumb.routeLink ?? $index;
      let isLast = $last
    ) {
      <li class="xng-breadcrumb-item">
        @if (!isLast) {
          <a
            class="xng-breadcrumb-link"
            [class.xng-breadcrumb-link-disabled]="breadcrumb.disable"
            [attr.aria-disabled]="breadcrumb.disable"
            [attr.tabIndex]="breadcrumb.disable ? -1 : 0"
            rel="noopener noreferrer"
            [routerLink]="breadcrumb.routeLink"
            [queryParams]="breadcrumb.queryParams"
            [fragment]="breadcrumb.fragment"
          >
            <ng-container
              *ngTemplateOutlet="label; context: { $implicit: breadcrumb }"
            ></ng-container>
          </a>
        } @else {
          <span class="xng-breadcrumb-trail">
            <ng-container
              *ngTemplateOutlet="label; context: { $implicit: breadcrumb }"
            ></ng-container>
          </span>
        }
      </li>
      @if (!isLast) {
        <li class="xng-breadcrumb-separator" aria-hidden="true">
          <mat-icon class="material-icons-round">chevron_right</mat-icon>
        </li>
      }
    }
  </ol>
</nav>

<ng-template #label let-breadcrumb>
  @if (breadcrumb.label | translate | breadcrumbParse: breadcrumb.info | async; as breadcrumbText) {
    <span [title]="breadcrumbText">{{ breadcrumbText }}</span>
  }
</ng-template>
